// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1518":"4c28caa534500df1","5428":"a6014bc7bee606d2","7581":"89f1a3f09275a389","9812":"a3c87a59dd697cba"}[chunkId] + ".js";
};